<template>
	<div>
		<BaseHeader :title="$t('compensation_overview').toString()" />
		<div class="main" v-if="!isLoading">
			<!-- <div :title="$t('compensations').toString()"> -->
			<div>
				<div class="mb-4">
					<div class="flex gap-4 justify-end" style="align-items: end">
						<BaseSelect
							ref="compensatedBaseSelect"
							v-model="selectedFilterCompensated"
							:multiple="false"
							:options="compensatedFilter"
							:filter-only="true"
							class="w-48"
							style="padding-right: 0px!important; padding-bottom: 0px!important;"
							:label="$t('status')"
							@changed="getAllCompensations"
							:title="$t('select_status').toString()"
						/>
						<BaseSelect
							ref="monthBaseSelect"
							v-model="selectedMonth"
							:multiple="false"
							:options="monthFilter"
							:filter-only="true"
							class="w-48"
							style="padding-right: 0px!important; padding-bottom: 0px!important;"
							:label="$t('month')"
							@changed="getAllCompensations"
							:title="$t('select_month').toString()"
						/>
						<BaseSelect
							ref="yearBaseSelect"
							v-model="selectedYear"
							:multiple="false"
							:options="yearsOptions"
							:filter-only="true"
							class="w-48"
							style="padding-right: 0px!important; padding-bottom: 0px!important;"
							:label="$t('year')"
							@changed="getAllCompensations"
							:title="$t('select_year').toString()"
						/>
						<BaseSelect
							ref="queryBaseSelect"
							v-model="selectedFilter"
							:multiple="false"
							:options="queryFilter"
							:filter-only="true"
							class="w-48"
							style="padding-right: 0px!important; padding-bottom: 0px!important;"
							:label="$t('filter')"
							@changed="getAllCompensations"
							:title="$t('select_assessor').toString()"
						/>
					</div>
				</div>
				<div class="flex flex-col">
					<div>
						<div class="m-4" v-if="this.compensations && this.compensations.length <= 0">
							<b>{{ $t('no_processes') }}</b>
						</div>
						<div
							class="align-middle inline-block min-w-full shadow overflow-hiddenborder-gray-200 rounded"
							v-if="this.compensations && this.compensations.length > 0"
						>
							<div v-for="compensation in this.compensations" :key="compensation.id">
								<div class="flex flex-row bg-connectProBlue rounded-t text-white p-4" style="text-align: start">
									<div class="w-2/5">Name: {{ compensation.company.first_name }} {{ compensation.company.last_name }}</div>
									<div class="w-1/5">Vorsteuer: {{ compensation.company.exclude_taxes ? 'Ja' : 'Nein' }}</div>
									<div class="w-1/5">Anzahl: {{ compensation.meta.count }} - {{ parseCompensation(compensation) }} EUR</div>
									<div class="w-1/5" v-if="selectedFilterCompensated.value === 0">
										<DocumentFileUploader :instant-upload="false" @input="uploadDocument($event, compensation)" accept="application/pdf">
											<font-awesome-icon :icon="['fas', 'upload']" class="upload-icon text-white mr-2 cursor-pointer" />
										</DocumentFileUploader>
									</div>
									<div class="w-1/5 flex flex-row items-center gap-8" v-else-if="selectedFilterCompensated.value === 1">
										<div :title="$t('download_compensation').toString()" @click="downloadCompensationFile(compensation)">
											<font-awesome-icon :icon="['fas', 'download']" class="upload-icon text-white mr-2 cursor-pointer" />
										</div>
										<div>
											<DocumentFileUploader :instant-upload="false" @input="updateDocument($event, compensation)" accept="application/pdf">
												<font-awesome-icon :icon="['fas', 'upload']" class="upload-icon text-white mr-2 cursor-pointer" />
											</DocumentFileUploader>
										</div>
									</div>
								</div>
								<div class="flex flex-row p-4 border-b" style="text-align: start" v-for="brokerCase in compensation.cases" :key="brokerCase.id">
									<div class="w-3/4">Name: {{ brokerCase.first_name }} {{ brokerCase.last_name }}</div>
									<div class="w-1/4">Status: {{ getCaseStatus(brokerCase) }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<LoadingSpinner v-else />
		<router-view />
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import Authentication from '@/mixins/Authentication';
import DamageAssessorCaseRepository from '@/api/repositories/DamageAssessorCaseRepository';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import { getGermanDate, getOptionFromOptionsArray } from '../../plugins/Utils';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import DocumentFileUploader from '@/components/forms/inputs/DocumentFileUploader.vue';

export default {
	name: 'BrokerCompensationOverview',
	components: {
		DocumentFileUploader,
		BaseSelect,
		LoadingSpinner,
		BaseHeader,
	},
	mixins: [Authentication],
	data() {
		return {
			isLoading: false,
			isUploading: false,
			per_page: { display: '25', value: 25 },
			compensations: [],
			queryFilter: [],
			yearFilter: [],
			monthFilter: [],
			compensatedFilter: [
				{ display: 'Offen', value: 0 },
				{ display: 'Vergütet', value: 1 },
			],
			selectedFilter: null,
			selectedYear: null,
			selectedMonth: null,
			selectedFilterCompensated: { display: 'Offen', value: 0 },
			uploadedCompensationDoc: null,
			isDocument: false,
			isLoadingDocument: false,
		};
	},
	mounted() {
		this.yearFilter = [getOptionFromOptionsArray(this.yearsOptions, this.currentYear)];
		this.monthFilter = this.months;
		this.selectedMonth = this.months.find(monthElement => monthElement.value === this.currentMonth);
		this.selectedYear = this.yearFilter.find(yearElement => yearElement.value === this.currentYear);
		this.isLoading = true;
		this.$root.$on('updateCase', () => {
			this.$store.commit('clearCompensation');
			this.getAllCompensations();
		});
		this.getEmployees();
	},
	computed: {
		months() {
			const monthStrings = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
			return monthStrings.map((monthString, index) => {
				return {
					display: monthString,
					value: index + 1,
				};
			});
		},
		currentYear() {
			return new Date().getFullYear();
		},
		currentMonth() {
			return new Date().getMonth() + 1;
		},
		yearsOptions() {
			const list = [];
			const year = this.currentYear;
			for (let i = year; i > year - 10; i--) {
				list.push({
					display: i,
					value: i,
				});
			}
			return list;
		},
	},
	methods: {
		getGermanDate,
		parseCompensation(compensation) {
			if (compensation.meta.amount_cents) {
				return new Intl.NumberFormat('de-DE').format(compensation.meta.amount_cents / 100);
			} else {
				return 'O EUR';
			}
		},
		getCaseStatus(brokerCase) {
			let label = '';
			if (brokerCase.status === 'succeed') {
				label = 'Erledigt';
			} else {
				label = 'Offen';
			}
			if (brokerCase.compensated) {
				label = label + ' - ' + 'Vergütet';
			} else {
				label = label + ' - ' + 'Vergütung offen';
			}
			return label;
		},
		getAllCompensations() {
			new DamageAssessorCaseRepository()
				.getCompensations(this.selectedMonth.value, this.selectedYear.value, this.selectedFilter.value, this.selectedFilterCompensated.value)
				.then(response => {
					this.compensations = response.data;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
				});
		},
		getEmployees() {
			new DamageAssessorCaseRepository()
				.getCompanyEmployees(this.$store.getters.getUser.person.company.id)
				.then(response => {
					this.queryFilter = response.data.data.map(element => {
						return {
							value: element.person.personableId,
							display: element.person.firstName + ' ' + element.person.lastName,
						};
					});
					this.queryFilter.unshift({
						value: 'all',
						display: 'Alle',
					});
					this.selectedFilter = this.queryFilter[0];
				})
				.then(_ => {
					this.getAllCompensations();
				});
		},
		uploadDocument($event, compensation) {
			const type = $event.split('/');
			this.uploadedCompensationDoc = $event;
			this.isDocument = type[0] !== 'data:image';
			this.$store.commit('setCompensation', {
				compensation: compensation,
				compensationFile: $event,
				month: this.selectedMonth.value,
				year: this.selectedYear.value,
			});
			this.$router.push({ name: 'finishCompensation' });
		},
		updateDocument($event, compensation) {
			const type = $event.split('/');
			this.uploadedCompensationDoc = $event;
			this.isDocument = type[0] !== 'data:image';
			this.$store.commit('setUpdateCompensation', {
				compensation: compensation,
				compensationFile: $event,
			});
			this.$router.push({ name: 'updateCompensation' });
		},
		base64ToArrayBuffer(base64) {
			const binaryString = atob(base64);
			const bytes = new Uint8Array(binaryString.length);
			for (let i = 0; i < binaryString.length; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return bytes.buffer;
		},
		downloadCompensationFile(compensation) {
			if (this.isLoadingDocument === true) {
				return;
			}
			this.isLoadingDocument = true;
			new DamageAssessorCaseRepository().downloadFileForCompensation(compensation.meta.compensation.id).then(response => {
				if (response.data) {
					const blob = new Blob([this.base64ToArrayBuffer(response.data.base64content.split(',')[1])], { type: 'application/pdf' });
					const name =
						compensation.company.first_name +
						'_' +
						compensation.company.last_name +
						'_' +
						getGermanDate(compensation.meta.compensation.month).slice(3) +
						'.pdf';
					const resolvingUrl = URL.createObjectURL(blob);
					const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;
					setTimeout(function() {
						window.open(viewerUrl, '_blank');
						window.URL.revokeObjectURL(viewerUrl);
					}, 200);
				}
				this.isLoadingDocument = false;
			});
		},
		updateCompensation(compensation) {
			new DamageAssessorCaseRepository().updateCompensation();
		},
	},
};
</script>

<style lang="scss" scoped>
.upload-icon {
	transition: transform 0.15s ease;
}

.upload-icon:active {
	transform: scale(0.9);
}
</style>
